import React from 'react';
import { connect } from 'react-redux';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { injectIntl } from 'react-intl';

import Table from 'src/componentes/table/index.jsx';
import ContentManager from 'src/componentes/content-manager';
import { capitalizeFirstLetter } from 'src/utils/string';
import Badge from 'src/componentes/Badge';

import ListRisco from 'src/paginas/gestao-risco/risco/RiscoListView';
import css from 'src/utils/css';
import { defineBgColorByScore } from 'src/paginas/gestao-risco/matriz-risco/utils/matriz_com_score.utils';

const classes = css`
  .verticalTxtTh {
    writing-mode: tb-rl;
    vertical-align: middle !important;
  }

  .fillAvaliableSpace {
    position: absolute;
    right: 0px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    margin: 0px !important;
  }

  .parentOfFillAvaliableSpace {
    position: relative;
  }

  .renderAllTxt {
    padding: 0px !important;
  }

  .centralizedInsideAbs {
    color: #000000 !important;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  .textoTruncado {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
`;

class TabelaMatrizRiscoComScore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverOpenId: null,
    };
  }

  openPop(open, id) {
    if (this.state.popoverOpenId === id || !this.state.popoverOpenId)
      this.setState({ popoverOpenId: open ? id : null });
  }

  handleRiscoClick(
    score,
    riscoAvaliacoes,
    severidade,
    probabilidade,
    inerente
  ) {
    const riscos =
      riscoAvaliacoes && inerente
        ? riscoAvaliacoes.filter(
            (a) =>
              a.severidadeInerente.id == severidade.id &&
              a.probabilidadeInerente.id == probabilidade.id
          )
        : riscoAvaliacoes.filter(
            (a) =>
              a.severidade.id == severidade.id &&
              a.probabilidade.id == probabilidade.id
          );

    if (riscos && riscos.length) {
      let { resources } = this.props;

      ContentManager.addContent(
        <ListRisco
          openLastFilter={true}
          usarFiltroSalvo={true}
          showModal={true}
          showNew={false}
          params={{ idsSelecionados: riscos.map(({ risco: { id } }) => id) }}
          title={capitalizeFirstLetter(resources.risco)}
        />
      );
    }
  }

  getAvaliacoes(
    riscoAvaliacoes,
    severidade,
    probabilidade,
    inerente,
    somenteSelecionados = false
  ) {
    if (inerente) {
      const avaliacaoInerente = riscoAvaliacoes.filter(
        (a) =>
          a.severidadeInerente?.id == severidade.severidade.id &&
          a.probabilidadeInerente?.id == probabilidade.probabilidade.id &&
          (!somenteSelecionados ||
            this.props.idsSelecionados?.includes(a.risco.id))
      );

      if (avaliacaoInerente.length === 0) {
        return null;
      }

      return avaliacaoInerente;
    }

    const avaliacao = riscoAvaliacoes.filter(
      (a) =>
        a.severidade?.id == severidade?.severidade?.id &&
        a.probabilidade?.id == probabilidade?.probabilidade?.id &&
        (!somenteSelecionados ||
          this.props.idsSelecionados?.includes(a.risco.id))
    );

    if (avaliacao.length === 0) {
      return null;
    }

    return avaliacao;
  }

  getAvaliacao(riscoAvaliacoes, severidade, probabilidade, inerente) {
    const avaliacao = this.getAvaliacoes(
      riscoAvaliacoes,
      severidade,
      probabilidade,
      inerente
    );

    if (!avaliacao) return null;
    return avaliacao[0];
  }

  countOfRiscoAtScore(
    riscoAvaliacoes,
    severidade,
    probabilidade,
    inerente,
    showScore
  ) {
    if (inerente) {
      const avaliacaoInerente = this.getAvaliacoes(
        riscoAvaliacoes,
        severidade,
        probabilidade,
        inerente,
        this.props.idsSelecionados?.length > 0 &&
          this.rowSelected(riscoAvaliacoes, severidade, probabilidade, inerente)
      );

      if (!avaliacaoInerente || avaliacaoInerente.length === 0) {
        return 0;
      }

      return avaliacaoInerente
        ? showScore
          ? avaliacaoInerente[0].scoreInerente
          : avaliacaoInerente.length
        : 0;
    }

    const avaliacao = this.getAvaliacoes(
      riscoAvaliacoes,
      severidade,
      probabilidade,
      inerente,
      this.props.idsSelecionados?.length > 0 &&
        this.rowSelected(riscoAvaliacoes, severidade, probabilidade, inerente)
    );

    if (!avaliacao || avaliacao.length === 0) {
      return 0;
    }

    return avaliacao ? (showScore ? avaliacao[0].score : avaliacao.length) : 0;
  }

  getSelectedsIds(riscoAvaliacoes, severidade, probabilidade, inerente) {
    const riscos =
      riscoAvaliacoes && inerente
        ? riscoAvaliacoes.filter(
            (a) =>
              a.severidadeInerente &&
              a.severidadeInerente.id == severidade.severidade.id &&
              a.probabilidadeInerente &&
              a.probabilidadeInerente.id == probabilidade.probabilidade.id
          )
        : riscoAvaliacoes.filter(
            (a) =>
              a.severidade &&
              a.severidade.id == severidade.severidade.id &&
              a.probabilidade &&
              a.probabilidade.id == probabilidade.probabilidade.id
          );

    return riscos.length == 0 ? [] : riscos.map(({ risco: { id } }) => id);
  }

  getTextColorForBg(bgColor) {
    if (!bgColor) return '#000000'; // Retorna preto como padrão se não houver cor

    // Remove o '#' se ele existir
    const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;

    // Converte o hexadecimal para valores R, G, B
    const r = parseInt(color.substring(0, 2), 16); // R
    const g = parseInt(color.substring(2, 4), 16); // G
    const b = parseInt(color.substring(4, 6), 16); // B

    // Fórmula da W3C para calcular a luminância (percepção de brilho)
    const luminancia = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Se a luminância for maior que 0.5, o fundo é claro -> use texto preto.
    // Caso contrário, o fundo é escuro -> use texto branco.
    return luminancia > 0.5 ? '#000000' : '#FFFFFF';
  }

  setFilter(riscoAvaliacoes, severidade, probabilidade, inerente) {
    const idsSelecionados = this.getSelectedsIds(
      riscoAvaliacoes,
      severidade,
      probabilidade,
      inerente
    );

    const cancelSelection =
      this.props.idsSelecionados &&
      JSON.stringify(this.props.idsSelecionados.sort()) ===
        JSON.stringify(idsSelecionados.sort());

    if (cancelSelection) {
      if (idsSelecionados.length !== 0)
        this.props.setFilter &&
          this.props.setFilter(cancelSelection ? [] : idsSelecionados, {}, {});
    } else
      this.props.setFilter &&
        this.props.setFilter(idsSelecionados, severidade, probabilidade);
  }

  rowSelected(riscoAvaliacoes, severidade, probabilidade, inerente) {
    if (!this.props.idsSelecionados || this.props.idsSelecionados.length === 0)
      return true;

    const idsRow = this.getSelectedsIds(
      riscoAvaliacoes,
      severidade,
      probabilidade,
      inerente
    );

    const result = this.props.idsSelecionados.some((x) => {
      if (idsRow.includes(x)) return true;
    });

    return result;
  }

  setPositionMouse(column, inerente) {
    this.props.setPositionMouse &&
      this.props.setPositionMouse(column, inerente);
  }

  getPopOver(item, chave, inerente) {
    if (!item || !chave) return;

    const { resources, intl } = this.props;
    return (
      <Popover
        key={`Popover-${chave}`}
        placement="right"
        isOpen={this.state.popoverOpenId == chave}
        target={chave}
      >
        <PopoverHeader key={`PopoverHeader-${chave}`}>
          {capitalizeFirstLetter(
            intl.formatMessage(
              { id: inerente ? 'labelRiscoInerente' : 'labelRiscoResidual' },
              { risco: resources.risco }
            )
          )}
        </PopoverHeader>
        <PopoverBody key={`PopoverBody-${chave}`}>
          {inerente ? (
            <span>
              <strong>
                {capitalizeFirstLetter(
                  intl.formatMessage({ id: 'labelScoreInerente' })
                )}
                : {item.scoreInerente}
              </strong>
            </span>
          ) : (
            <span>
              <strong>
                {capitalizeFirstLetter(
                  intl.formatMessage({ id: 'labelScoreResidual' })
                )}
                : {item.score}
              </strong>
            </span>
          )}
        </PopoverBody>
      </Popover>
    );
  }

  getItemsAtScore(riscoAvaliacoes, severidade, probabilidade, inerente) {
    const itens = this.getAvaliacoes(
      riscoAvaliacoes,
      severidade,
      probabilidade,
      inerente
    );
    return Array.isArray(itens) ? itens : [];
  }

  renderCellDisplayContent(itens, exibirCodigo) {
    if (!exibirCodigo) return itens.length;

    const codigos = itens.map((item) => item.codigoItemImpactado);

    const textoCompleto = codigos.join(', ');

    if (!textoCompleto) return null;

    return textoCompleto;
  }

  renderCellTooltipContent(itens) {
    if (itens.length === 0) return '';

    const codigos = itens.map((item) => item.codigo);
    return `${codigos.join(', ')}`;
  }

  renderRows(matrizFarol, inverter) {
    if (inverter) return this.renderRowsInvertida(matrizFarol);

    const {
      apenasMaiorQueZero,
      inerente,
      isWidget,
      heightBase,
      intl,
      informarScore,
      exibirCodigoItem,
      idsSelecionados,
    } = this.props;
    const {
      scoreProbabilidades,
      scoreSeveridades,
      grauMatrizRisco,
      riscoAvaliacoes,
    } = matrizFarol;
    const _defineBgColorByScore = defineBgColorByScore(
      grauMatrizRisco ? grauMatrizRisco : []
    );
    const heightMatrizRisco = isWidget ? `${heightBase * 0.1}px` : '60px';

    return (
      scoreProbabilidades &&
      scoreProbabilidades.length > 0 &&
      scoreProbabilidades.map((probabilidade, indexLinhaProbabilidade) => (
        <tr
          key={`trKeyProb-${probabilidade.id}`}
          style={{ height: heightMatrizRisco }}
        >
          <td
            key={`tdKeyProb-${probabilidade.id}`}
            className={`font-weight-bold text-center ${classes.renderAllTxt}`}
            style={{ padding: '20px 0px 0px 0.75rem', verticalAlign: 'middle' }}
          >
            {probabilidade.probabilidade.nome}
          </td>
          {scoreSeveridades &&
            scoreSeveridades.length > 0 &&
            scoreSeveridades.map((severidade, indexLinhaSeveridade) => {
              const itensInerentes = this.getItemsAtScore(
                riscoAvaliacoes,
                severidade,
                probabilidade,
                true
              );
              const itensResiduais = this.getItemsAtScore(
                riscoAvaliacoes,
                severidade,
                probabilidade,
                false
              );
              const styleBg = _defineBgColorByScore(
                severidade.score * probabilidade.score
              );
              const bgColor = styleBg.background;
              const textColor = this.getTextColorForBg(bgColor);
              const textStyle = { color: textColor };
              if (exibirCodigoItem) {
                textStyle.textAlign = 'left';
                textStyle.fontSize = '0.65rem';
                textStyle.paddingLeft = '8px';
              }
              const hasScore =
                itensInerentes.length > 0 || itensResiduais.length > 0;
              const tooltipContentInerente =
                this.renderCellTooltipContent(itensInerentes);
              const tooltipContentResidual =
                this.renderCellTooltipContent(itensResiduais);

              return (
                <td
                  key={`cell-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                  style={{ padding: '0px' }}
                  className={`${classes.parentOfFillAvaliableSpace} cursor-pointer`}
                  onClick={() =>
                    this.setFilter(
                      riscoAvaliacoes,
                      severidade,
                      probabilidade,
                      inerente
                    )
                  }
                >
                  <div
                    key={`div-cell-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                    onMouseEnter={() =>
                      this.setPositionMouse(indexLinhaSeveridade, inerente)
                    }
                    onMouseLeave={() => this.setPositionMouse(-1)}
                    style={Object.assign(
                      styleBg,
                      this.rowSelected(
                        riscoAvaliacoes,
                        severidade,
                        probabilidade,
                        inerente
                      )
                        ? idsSelecionados && idsSelecionados.length > 0
                          ? {
                              opacity: '1',
                              borderStyle: 'solid',
                              borderWidth: '1px',
                              borderColor: 'black',
                            }
                          : !hasScore && informarScore
                          ? { opacity: '0.2' }
                          : {}
                        : { opacity: '0.2' }
                    )}
                    className={`text-center h5 ${
                      classes.fillAvaliableSpace
                    } ${'text-hover-link'}`}
                  >
                    {!informarScore &&
                      (!apenasMaiorQueZero || itensResiduais.length > 0) &&
                      (exibirCodigoItem ? (
                        <div
                          style={textStyle}
                          className="texto-truncado"
                          title={this.renderCellDisplayContent(
                            inerente ? itensInerentes : itensResiduais,
                            true
                          )}
                        >
                          {this.renderCellDisplayContent(
                            inerente ? itensInerentes : itensResiduais,
                            true
                          )}
                        </div>
                      ) : (
                        <Badge
                          color="light"
                          pill
                          className={classes.centralizedInsideAbs}
                        >
                          {this.renderCellDisplayContent(
                            inerente ? itensInerentes : itensResiduais,
                            false
                          )}
                        </Badge>
                      ))}
                    {informarScore && (
                      <div className="pt-4">
                        {itensInerentes.length > 0 && (
                          <>
                            {exibirCodigoItem ? (
                              <span
                                id={`span-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                                style={textStyle}
                                className="texto-truncado"
                                title={this.renderCellDisplayContent(
                                  itensInerentes,
                                  true
                                )}
                                onMouseOver={this.openPop.bind(
                                  this,
                                  true,
                                  `span-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                )}
                                onMouseOut={this.openPop.bind(
                                  this,
                                  false,
                                  `span-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                )}
                              >
                                {intl.formatMessage({
                                  id: 'labelSiglaRiscoInerente',
                                })}{' '}
                                (
                                {this.renderCellDisplayContent(
                                  itensInerentes,
                                  true
                                )}
                                )
                              </span>
                            ) : (
                              <Badge
                                id={`badge-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                                color="light"
                                pill
                                className={classes.centralizedInsideAbs}
                                onMouseOver={this.openPop.bind(
                                  this,
                                  true,
                                  `badge-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                )}
                                onMouseOut={this.openPop.bind(
                                  this,
                                  false,
                                  `badge-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                )}
                              >
                                {intl.formatMessage({
                                  id: 'labelSiglaRiscoInerente',
                                })}{' '}
                                (
                                {this.renderCellDisplayContent(
                                  itensInerentes,
                                  false
                                )}
                                )
                              </Badge>
                            )}
                            {this.getPopOver(
                              tooltipContentInerente,
                              exibirCodigoItem
                                ? `span-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                : `badge-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                            )}
                          </>
                        )}
                        {itensResiduais.length > 0 && (
                          <>
                            {exibirCodigoItem ? (
                              <span
                                id={`span-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                                style={textStyle}
                                className="texto-truncado"
                                title={this.renderCellDisplayContent(
                                  itensResiduais,
                                  true
                                )}
                                onMouseOver={this.openPop.bind(
                                  this,
                                  true,
                                  `span-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                )}
                                onMouseOut={this.openPop.bind(
                                  this,
                                  false,
                                  `span-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                )}
                              >
                                {intl.formatMessage({
                                  id: 'labelSiglaRiscoResidual',
                                })}{' '}
                                (
                                {this.renderCellDisplayContent(
                                  itensResiduais,
                                  true
                                )}
                                )
                              </span>
                            ) : (
                              <Badge
                                id={`badge-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                                color="light"
                                pill
                                className={classes.centralizedInsideAbs}
                                onMouseOver={this.openPop.bind(
                                  this,
                                  true,
                                  `badge-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                )}
                                onMouseOut={this.openPop.bind(
                                  this,
                                  false,
                                  `badge-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                )}
                              >
                                {intl.formatMessage({
                                  id: 'labelSiglaRiscoResidual',
                                })}{' '}
                                (
                                {this.renderCellDisplayContent(
                                  itensResiduais,
                                  false
                                )}
                                )
                              </Badge>
                            )}
                            {this.getPopOver(
                              tooltipContentResidual,
                              exibirCodigoItem
                                ? `span-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                : `badge-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </td>
              );
            })}
        </tr>
      ))
    );
  }

  renderRowsInvertida(matrizFarol) {
    const {
      apenasMaiorQueZero,
      heightBase,
      inerente,
      isWidget,
      informarScore,
      intl,
      exibirCodigoItem,
      idsSelecionados,
    } = this.props;
    const {
      scoreProbabilidades,
      scoreSeveridades,
      grauMatrizRisco,
      riscoAvaliacoes,
    } = matrizFarol;
    if (!grauMatrizRisco) return <></>;
    const _defineBgColorByScore = defineBgColorByScore(grauMatrizRisco);
    const heightMatrizRisco = isWidget ? `${heightBase * 0.1}px` : '60px';

    return (
      scoreSeveridades &&
      scoreSeveridades.length > 0 &&
      scoreSeveridades.map((severidade, indexLinhaSeveridade) => (
        <tr
          key={`trSeveridadeKey-${indexLinhaSeveridade}`}
          style={{ height: heightMatrizRisco }}
        >
          <td
            key={`tdSeveridadeKey-${indexLinhaSeveridade}`}
            className={`font-weight-bold text-center ${classes.renderAllTxt}`}
            style={{ padding: '20px 0px 0px 0.75rem', verticalAlign: 'middle' }}
          >
            {severidade.severidade.nome}
          </td>
          {scoreProbabilidades &&
            scoreProbabilidades.length > 0 &&
            scoreProbabilidades.map(
              (probabilidade, indexLinhaProbabilidade) => {
                const itensInerentes = this.getItemsAtScore(
                  riscoAvaliacoes,
                  severidade,
                  probabilidade,
                  true
                );

                const itensResiduais = this.getItemsAtScore(
                  riscoAvaliacoes,
                  severidade,
                  probabilidade,
                  false
                );
                const styleBg = _defineBgColorByScore(
                  severidade.score * probabilidade.score
                );
                const bgColor = styleBg.background;
                const textColor = this.getTextColorForBg(bgColor);
                const textStyle = { color: textColor };
                if (exibirCodigoItem) {
                  textStyle.textAlign = 'left';
                  textStyle.fontSize = '0.65rem';
                  textStyle.paddingLeft = '8px';
                }
                const hasScore =
                  itensInerentes.length > 0 || itensResiduais.length > 0;
                const tooltipContentInerente =
                  this.renderCellTooltipContent(itensInerentes);
                const tooltipContentResidual =
                  this.renderCellTooltipContent(itensResiduais);

                return (
                  <td
                    key={`cell-invertida-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                    style={{ padding: '0px' }}
                    className={`${classes.parentOfFillAvaliableSpace} cursor-pointer`}
                    onClick={() =>
                      this.setFilter(
                        riscoAvaliacoes,
                        severidade,
                        probabilidade,
                        inerente
                      )
                    }
                  >
                    <div
                      key={`div-invertida-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                      onMouseEnter={() =>
                        this.setPositionMouse(indexLinhaProbabilidade, inerente)
                      }
                      onMouseLeave={() => this.setPositionMouse(-1)}
                      style={Object.assign(
                        styleBg,
                        this.rowSelected(
                          riscoAvaliacoes,
                          severidade,
                          probabilidade,
                          inerente
                        )
                          ? idsSelecionados && idsSelecionados.length > 0
                            ? {
                                opacity: '1',
                                borderStyle: 'solid',
                                borderWidth: '1px',
                                borderColor: 'black',
                              }
                            : !hasScore && informarScore
                            ? { opacity: '0.2' }
                            : {}
                          : { opacity: '0.2' }
                      )}
                      className={`text-center h5 ${
                        classes.fillAvaliableSpace
                      } ${'text-hover-link'}`}
                    >
                      {!informarScore &&
                        (!apenasMaiorQueZero || itensResiduais.length > 0) &&
                        (exibirCodigoItem ? (
                          <div
                            style={textStyle}
                            className="texto-truncado"
                            title={this.renderCellDisplayContent(
                              inerente ? itensInerentes : itensResiduais,
                              true
                            )}
                          >
                            {this.renderCellDisplayContent(
                              inerente ? itensInerentes : itensResiduais,
                              true
                            )}
                          </div>
                        ) : (
                          <Badge
                            color="light"
                            pill
                            className={classes.centralizedInsideAbs}
                          >
                            {this.renderCellDisplayContent(
                              inerente ? itensInerentes : itensResiduais,
                              false
                            )}
                          </Badge>
                        ))}
                      {informarScore && (
                        <div className="pt-4">
                          {itensInerentes.length > 0 && (
                            <>
                              {exibirCodigoItem ? (
                                <span
                                  id={`inv-span-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                                  style={textStyle}
                                  className="texto-truncado"
                                  title={this.renderCellDisplayContent(
                                    itensInerentes,
                                    true
                                  )}
                                  onMouseOver={this.openPop.bind(
                                    this,
                                    true,
                                    `inv-span-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  )}
                                  onMouseOut={this.openPop.bind(
                                    this,
                                    false,
                                    `inv-span-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  )}
                                >
                                  {intl.formatMessage({
                                    id: 'labelSiglaRiscoInerente',
                                  })}{' '}
                                  (
                                  {this.renderCellDisplayContent(
                                    itensInerentes,
                                    true
                                  )}
                                  )
                                </span>
                              ) : (
                                <Badge
                                  id={`inv-badge-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                                  color="light"
                                  pill
                                  className={classes.centralizedInsideAbs}
                                  onMouseOver={this.openPop.bind(
                                    this,
                                    true,
                                    `inv-badge-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  )}
                                  onMouseOut={this.openPop.bind(
                                    this,
                                    false,
                                    `inv-badge-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  )}
                                >
                                  {intl.formatMessage({
                                    id: 'labelSiglaRiscoInerente',
                                  })}{' '}
                                  (
                                  {this.renderCellDisplayContent(
                                    itensInerentes,
                                    false
                                  )}
                                  )
                                </Badge>
                              )}
                              {this.getPopOver(
                                tooltipContentInerente,
                                exibirCodigoItem
                                  ? `inv-span-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  : `inv-badge-inerente-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                              )}
                            </>
                          )}
                          {itensResiduais.length > 0 && (
                            <>
                              {exibirCodigoItem ? (
                                <span
                                  id={`inv-span-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                                  style={textStyle}
                                  className="texto-truncado"
                                  title={this.renderCellDisplayContent(
                                    itensResiduais,
                                    true
                                  )}
                                  onMouseOver={this.openPop.bind(
                                    this,
                                    true,
                                    `inv-span-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  )}
                                  onMouseOut={this.openPop.bind(
                                    this,
                                    false,
                                    `inv-span-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  )}
                                >
                                  {intl.formatMessage({
                                    id: 'labelSiglaRiscoResidual',
                                  })}{' '}
                                  (
                                  {this.renderCellDisplayContent(
                                    itensResiduais,
                                    true
                                  )}
                                  )
                                </span>
                              ) : (
                                <Badge
                                  id={`inv-badge-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`}
                                  color="light"
                                  pill
                                  className={classes.centralizedInsideAbs}
                                  onMouseOver={this.openPop.bind(
                                    this,
                                    true,
                                    `inv-badge-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  )}
                                  onMouseOut={this.openPop.bind(
                                    this,
                                    false,
                                    `inv-badge-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  )}
                                >
                                  {intl.formatMessage({
                                    id: 'labelSiglaRiscoResidual',
                                  })}{' '}
                                  (
                                  {this.renderCellDisplayContent(
                                    itensResiduais,
                                    false
                                  )}
                                  )
                                </Badge>
                              )}
                              {this.getPopOver(
                                tooltipContentResidual,
                                exibirCodigoItem
                                  ? `inv-span-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                                  : `inv-badge-residual-${indexLinhaSeveridade}-${indexLinhaProbabilidade}`
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                );
              }
            )}
        </tr>
      ))
    );
  }

  renderHead(severidades, probabilidades, resources, inverter) {
    if (inverter)
      return (
        <thead>
          <tr>
            <th></th>
            <th
              colSpan={probabilidades ? probabilidades.length : 0}
              className="text-center text-uppercase"
            >
              {resources.probabilidade}
            </th>
          </tr>
          <tr>
            <th
              className={`text-uppercase text-center ${classes.verticalTxtTh}`}
            >
              {resources.severidade}
            </th>
            {probabilidades &&
              probabilidades.length > 0 &&
              probabilidades.map((probabilidade, index) => (
                <th
                  key={`thKeyProb-${index}`}
                  onMouseEnter={() =>
                    this.setPositionMouse(index, this.props.inerente)
                  }
                  onMouseLeave={() => this.setPositionMouse(-1)}
                  className={`text-center ${classes.verticalTxtTh}`}
                  style={
                    this.props.positionInerente === this.props.inerente &&
                    this.props.positionMouse >= 0 &&
                    this.props.positionMouse === index
                      ? { backgroundColor: 'rgba(0, 0, 0, 0.075)' }
                      : {}
                  }
                >
                  {probabilidade.nome}
                </th>
              ))}
          </tr>
        </thead>
      );

    return (
      <thead>
        <tr>
          <th></th>
          <th
            colSpan={severidades ? severidades.length : 0}
            className="text-center text-uppercase"
          >
            {resources.severidade}
          </th>
        </tr>
        <tr>
          <th className={`text-uppercase text-center ${classes.verticalTxtTh}`}>
            {resources.probabilidade}
          </th>
          {severidades &&
            severidades.length > 0 &&
            severidades.map((severidade, index) => (
              <th
                key={`thKeySev-${index}`}
                onMouseEnter={() =>
                  this.setPositionMouse(index, this.props.inerente)
                }
                onMouseLeave={() => this.setPositionMouse(-1)}
                className={`text-center ${classes.verticalTxtTh}`}
                style={
                  this.props.positionInerente === this.props.inerente &&
                  this.props.positionMouse >= 0 &&
                  this.props.positionMouse === index
                    ? { backgroundColor: 'rgba(0, 0, 0, 0.075)' }
                    : {}
                }
              >
                {severidade.nome}
              </th>
            ))}
        </tr>
      </thead>
    );
  }

  render() {
    const { resources, matrizFarol, styleDiv, header } = this.props;

    if (!matrizFarol) return <></>;

    const { scoreSeveridades, scoreProbabilidades, inverter } = matrizFarol;

    const severidades =
      scoreSeveridades && scoreSeveridades.map((s) => s.severidade);
    const probabilidades =
      scoreProbabilidades && scoreProbabilidades.map((s) => s.probabilidade);

    return (
      <div>
        {header && (
          <p
            colSpan={probabilidades ? probabilidades.length : 0}
            className="pt-3 text-center text-uppercase font-weight-bolder text-muted"
          >
            {header}
          </p>
        )}
        <Table
          styleDiv={{ ...styleDiv }}
          style={{ tableLayout: 'fixed' }}
          responsive
          size="md"
          bordered
        >
          {this.renderHead(
            severidades,
            probabilidades,
            resources,
            inverter,
            header
          )}
          <tbody>{matrizFarol && this.renderRows(matrizFarol, inverter)}</tbody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(TabelaMatrizRiscoComScore));
